import React from 'react';
import PropTypes from 'prop-types';
import { find as _find } from 'lodash';

import { galleryNavigation as trackGalleryNavigation } from 'analytics/product';

import Gallery from 'components/Gallery/Gallery';
import localize from 'components/Localize/Localize';

import translations from './translations';

class MattressGallery extends React.Component {
  constructor(props) {
    super(props);

    const galleryData = this.props.t[this.props.product];

    this.state = {
      selectedImage: _find(Object.keys(galleryData), (key) => !!galleryData[key]),
    };

    this.updateSelectedImage = this.updateSelectedImage.bind(this);
  }

  updateSelectedImage(key, index) {
    this.setState({
      selectedImage: key,
    });
    trackGalleryNavigation(`Mattresses`, index);
  }

  render() {
    const galleryData = this.props.t[this.props.product];

    return (
      <Gallery
        galleryData={galleryData}
        onClick={this.updateSelectedImage}
        productCategory="Mattresses"
        selectedOption="gray"
        selectedSlide={this.state.selectedImage}
      />

    );
  }
}

MattressGallery.propTypes = {
  product: PropTypes.string.isRequired,
  t: PropTypes.object.isRequired,
};

export default localize(MattressGallery, translations);
